import React from 'react';
import styled, { keyframes } from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import { Theme } from '@tanium/theme-data';
import { BarFill, BarFillExpanded } from './themeDefinitions';

const getAnimation = (theme: Theme) => {
  const expand = keyframes({
    '0%, 25%, 100%': {
      height: '75%',
      color: BarFillExpanded(theme),
    },
    '12.5%': {
      height: '50%',
      color: BarFill(theme),
    },
  });
  return `${expand} 1s cubic-bezier(0.25, 0.1, 0.25, 1.0) infinite`;
};

interface Props {
  size?: number;
}

const Container = styled('div', { shouldForwardProp: (p) => p !== 'size' })<{
  size: number;
}>(({ size }) => ({
  position: 'relative',
  height: size,
  width: size,
}));

const Svg = styled('svg', {
  shouldForwardProp: (p) => !['index', 'width', 'spacing'].includes(p),
})<{
  index: number;
  width: number;
  spacing: number;
}>(
  css((theme) => ({
    display: 'block',
    position: 'absolute',
    animation: getAnimation(theme),
    top: '50%',
    height: '75%',
    color: BarFillExpanded(theme),
    transform: 'translateY(-50%)',
  })),
  ({ index, width, spacing }) => ({
    animationDelay: `${index * 0.2}s`,
    left: `${Math.round(index * (width + spacing))}px`,
    width,
  }),
);

export const SpinnerBars = ({ size = 32 }: Props) => {
  const barWidth = size / 5;

  return (
    <Container size={size}>
      {[0, 1, 2].map((index) => (
        <Svg key={index} index={index} width={barWidth} spacing={(size - barWidth * 3) / 2}>
          <rect x="0" y="0" width="100%" height="100%" fill="currentColor" />
        </Svg>
      ))}
    </Container>
  );
};
